export default "__VITE_ASSET__BBDdHSUd__"